import styled from 'styled-components';
import { Colors } from '../constants/colors';
import { rgba } from 'polished';
import { CheckedCheckMark } from './CheckMark';
import { Device } from '../constants/device';

type CardProps = {
  active?: boolean;
}

export const CardTitle = styled.div<CardProps>`
  font-size: 18px;
  line-height: 1.2;
  display: flex;
  align-items: center;
  text-align: left;
  justify-content: center;
  padding: 10px 20px;
  transition: color 0.2s ease-in-out;
  margin-bottom: 30px;
  color: ${props => props.active === true || props.active === undefined ? Colors.primary : Colors.dark};

  > strong {
    text-align: center;
  }

  svg {
    height: 37px;
    fill: ${props => props.active ? Colors.primary : Colors.dark};
    transition: fill 0.2s ease-in-out;

    + span {
      padding-top: 2px;
      margin-left: 10px;

      ${Device.downTablet} {
        display: flex;
        flex-direction: column;
      }
    }
  }
`;

export const CardBody = styled.div`
  flex: 1;

  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const CardFooter = styled.div`
  display: flex;
  width: 100%;

  > * {
    flex: 1;
  }
`;

export const Card = styled.div<CardProps>`
  padding: 35px 40px 55px;
  background: ${Colors.white};
  z-index: ${props => props.active ? 2 : 1};
  flex: 1;
  transition: background-color 0.2s ease-in-out;
  position: relative;
  display: flex;
  flex-direction: column;
  max-width: 420px;
  box-shadow: ${props => props.active ? `${rgba(0, 0, 0, 0.1)} 0 4px 12px` : 'none'};
  border: 1px solid ${Colors.borderColor};
  border-radius: ${props => props.active ? '0 0 6px 6px' : '6px'};

  :not(:only-child):first-child {
    ::before {
      inset: -1px -1px auto auto;
    }
  }

  ${Device.downTablet} {
    padding: 30px 30px 40px;
    min-width: 100%;
  }

  :hover {
    ${CardTitle} {
      color: ${Colors.primary};
    }

    ${CardTitle} svg {
      fill: ${Colors.primary}
    }
  }

  ::before {
    content: '';
    height: 5px;
    width: ${props => props.active === true || props.active === undefined ? 'calc(100% + 2px)' : 0};
    background: ${Colors.primary};
    position: absolute;
    inset: -1px auto auto -1px;
    transition: width 0.2s ease-in-out;
  }

  ${CheckedCheckMark} {
    color: ${props => props.active ? Colors.white : Colors.grey};
    background: ${props => props.active ? Colors.primary : Colors.borderColor};
    border-color: ${props => props.active ? Colors.primary : Colors.borderColor};
  }

  > * {
    pointer-events: ${props => props.active === true || props.active === undefined ? 'all' : 'none'};
  }
`;
